module.exports = __webpack_public_path__ + "static/media/mx.d6848d1e.svg";